import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { SingleShopType } from './data';
import {
  addShopList,
  editShopList,
  getShopListPage,
  removeShopList,
  importShopList,
} from './service';

export type ShopListState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleShopType[];
};

type ShopListModelType = {
  namespace: string;
  state: ShopListState;
  reducers: {
    ShopListReducer: Reducer<ShopListState>;
  };
  effects: {
    fetchShopListPageEffect: Effect;
    refreshDataEffect: Effect;
    addShopListEffect: Effect;
    editShopListEffect: Effect;
    removeShopListEffect: Effect;
    importShopListEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const ShopListModel: ShopListModelType = {
  namespace: 'shopList',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    ShopListReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as ShopListState;
    },
  },

  effects: {
    *fetchShopListPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getShopListPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'ShopListReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.shopList.current);
      const pageSize = yield select((state: any) => state.shopList.pageSize);
      yield put({
        type: 'fetchShopListPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    addShopListEffect: createEffect(addShopList),
    editShopListEffect: createEffect(editShopList),
    removeShopListEffect: createEffect(removeShopList),

    // 导入商户
    *importShopListEffect(
      { payload: { file, filter, sorter }, callback }: any,
      { call, put }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(importShopList, file);

        if (res && res.code === 0) {
          yield put({
            type: 'refreshDataEffect',
            payload: { filter, sorter },
          });
        }

        callback?.(res);
      } catch (e) {
        console.error('Import failed:', e);
        callback?.({ code: 1, message: '导入失败' });
      }
    },
  },

  subscriptions: {
    setup() {},
  },
};

export default ShopListModel;
